// extracted by mini-css-extract-plugin
export var block = "divider-panel-module--block--1d80b";